import { useMutation } from 'react-query';
import { network } from 'services/network';

const downloadExternalDocumentFile = async (params: QueryParams) => {
    const urlPath = `api/bo/downloadCardAssociatedDocument?docId=${params.documentId}`;

    const response = await network.post(urlPath, null, {
        transformRequest: [
            (data) => {
                return data;
            },
        ],
        responseType: 'blob',
    });

    const blob = new Blob([response.data], {
        type: response.headers['content-type'],
    });

    const url = window.URL.createObjectURL(blob);
    const w = window.open('', '_blank');
    if (w) {
        w.document.write(`
          <!doctype html><title>Image</title>
          <style>html,body{margin:0;background:#111;display:grid;place-items:center;height:100vh}</style>
          <img src="${url}" alt="" />
        `);
    }
};

export const useMutationDownloadExternalDocument = () => {
    return useMutation<unknown, QueryError, QueryParams>((params) => downloadExternalDocumentFile(params));
};

export interface QueryParams {
    documentId: number;
    fileName: string;
}
